import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { MainContextProvider } from 'components/layout/MainContext';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from 'styles';
import theme from 'theme';
import { AppRouter } from 'router/AppRouter';

const queryClient = new QueryClient();

export const App = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <GlobalStyles />
            <ThemeProvider theme={theme}>
                <MainContextProvider>
                    <BrowserRouter>
                        <AppRouter />
                    </BrowserRouter>
                </MainContextProvider>
            </ThemeProvider>
        </QueryClientProvider>
    );
};
